import { ApiHosts, handleResponseOld, makeGet } from './helpers';

/**
 * GET search/similaritemsgroups
 * @category Search API
 * @see https://github.com/LIVEauctioneers/search-party internal handlers for SimilarItemsGroups
 */
export type FetchSimilarItemsGroupsParams = {
    authToken: string;
    deployment: string;
    ipAddress: string;
    isBot: boolean;
    itemId: number;
    useChairishSimilarItems?: boolean;
    useScoutCategories?: boolean;
    useNewSimilarItems?: boolean;
    useSignalsBoost?: boolean;
};

export const fetchSimilarItemsGroups = ({
    authToken,
    deployment,
    ipAddress,
    isBot,
    itemId,
    useChairishSimilarItems,
    useScoutCategories,
    useNewSimilarItems,
    useSignalsBoost,
}: FetchSimilarItemsGroupsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'similaritemsgroups',
            authToken,
            deployment,
            ipAddress,
            path: ApiHosts.Search,
        });
        // SEAR-69 EXPERIMENT: useNewSimilarItems
        // SEAR-173 EXPERIMENT: useScoutCategories
        const query = {
            isBot,
            itemId,
            useChairishSimilarItems: useChairishSimilarItems ? 'true' : 'false',
            useNewSimilarItems: useNewSimilarItems ? 'true' : 'false',
            useScoutCategories: useScoutCategories ? 'true' : 'false',
            useSignalsBoost: useSignalsBoost ? 'true' : 'false',
        };
        request.query(query);
        request.end((err, response) => {
            handleResponseOld({ err, reject, resolve, response });
        });
    });

export default { fetchSimilarItemsGroups };
